import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';

export default function Navbar({ item, sections, socialAccounts, images }) {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const [color, setColor] = useState(null);
  const [hover1, setHover1] = useState(false);
  // const [hover2, setHover2] = useState(false);
  const [backgroundColor, setBackgroundColor] = useState(null);
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    const data = item?.get("data");
    const bgColor = item?.get("backgroundColor");
    const bg = item?.get("bgImage");
    const textColor = item?.get("fontColor");
    setData(data);
    setBackgroundImage(bg);
    setBackgroundColor(bgColor);
    setColor(textColor);
    //eslint-disable-next-line
  }, []);

  useEffect(() => { }, [socialAccounts]);
  open
    ? (document.body.style.overflow = "hidden")
    : (document.body.style.overflow = "unset");
  useEffect(() => { }, [open]);

  useEffect(() => {
    const img = images?.find((img) => img.id === data?.imageId);
    const logo = img?.get("image").toJSON();
    setLogo(logo?.url);
  }, [images, data?.imageId]);

  return (
    <header
      className="p-0"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundColor: backgroundColor,
        color: color,
      }}
      id="#navbar"
    >
      <div className="container">
        <div className="row align-items-center d-none d-lg-flex py-3">
          <div className="col-1 logo">
            <img
              src={logo || data?.image}
              alt="EvolveCoin"
              style={{ minWidth: 100 }}
            />
          </div>
          <div className="col-11 main-menu">
            <div className="menu-icon">
              <span className="top"></span>
              <span className="middle"></span>
              <span className="bottom"></span>
            </div>
            <nav className="onepage">
              <ul>
                <li >
                  <Link
                    to={`/white-paper`}
                    style={{ color: color }}
                  >
                    White Paper
                  </Link>
                </li>
                <li className="nav-btn">
                  <a
                    href={'https://evolvecoin.io/nft'}
                    style={{ color: color }} >
                    NFT
                  </a>
                </li>
                {sections?.map((section) => {
                  if (
                    section?.get("section") !== "header" &&
                    section?.get("section") !== "footer" &&
                    section?.get("section") !== "navbar" &&
                    section?.get("section") !== "characterSlider" &&
                    section?.get("section") !== "message"
                  ) {
                    return (
                      <li key={section.id}>
                        <a
                          href={`#${section?.get("section")}`}
                          style={{ color: color }}
                        >
                          {section?.get("section")}
                        </a>
                      </li>
                    );
                  } else {
                    return <span key={section.id}></span>;
                  }
                })}


                {data?.contractAddressButtonVisibility && (
                  <li className="nav-btn">
                    <a
                      href={data?.contractAddressButtonLink}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-sm fw-bolder py-1 px-2"
                      style={{
                        backgroundColor: hover1
                          ? data?.contractAddressButtonHoverBackground
                          : data?.contractAddressButtonBackground,
                        color: hover1
                          ? data?.contractAddressButtonHoverTextColor
                          : data?.contractAddressButtonTextColor,
                      }}
                      onMouseEnter={() => setHover1(true)}
                      onMouseLeave={() => setHover1(false)}
                    >
                      {data?.contractAddressButtonText}
                    </a>
                  </li>

                )}
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <div className="w-100" style={{ position: "relative" }}>
        <div className="row d-flex d-lg-none w-100 m-0">
          <div className="col-12 d-flex p-0">
            <button
              onClick={() => setOpen(!open)}
              className="btn d-block d-lg-none mt-2"
            >
              <svg
                fill="white"
                xmlns="http://www.w3.org/2000/svg"
                height="25px"
                id="Layer_1"
                version="1.1"
                viewBox="0 0 32 32"
                width="25px"
              >
                <path d="M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z" />
              </svg>
            </button>
          </div>

          <div className="col-12 logo d-flex justify-content-center">
            <div>
              <img
                src={logo || data?.image}
                alt="EvolveCoin"
                style={{ maxWidth: 200 }}
              />
            </div>
          </div>

          {open && (
            <div
              className="col-12 main-menu"
              style={{
                position: "fixed",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                backgroundColor: "#151720",
                color: color,
              }}
            >
              <ul className="list-group">
                <li
                  className="list-group-item  bg-transparent py-2 fw-bolder"
                  style={{ borderBottom: "1px solid rgb(53, 51, 62)" }}
                >
                  <div
                    href="/"
                    title="EvolveCoin"
                    className="w-50 d-inline-block"
                  >
                    <img
                      src={logo || data?.image}
                      alt="EvolveCoin"
                      style={{ width: 85 }}
                    />
                  </div>
                  <button
                    className="btn text-capitalize text-white bg-transparent fs-6 fw-bolder p-0 w-50 text-end"
                    onClick={() => setOpen(false)}
                  >
                    <svg
                      width={18}
                      height={18}
                      fill="white"
                      id="Layer_1"
                      version="1.1"
                      viewBox="0 0 512 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4  L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1  c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1  c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z" />
                    </svg>
                  </button>
                </li>
                <div className="text-center mt-4">
                  {sections?.map((section) => {
                    if (
                      section?.get("section") !== "header" &&
                      section?.get("section") !== "footer" &&
                      section?.get("section") !== "navbar" &&
                      section?.get("section") !== "characterSlider"
                    ) {
                      return (
                        <a
                          key={section.id}
                          className="text-center d-block mx-auto btn p-0 border-top-0 w-50"
                          onClick={() => setOpen(false)}
                          href={`#${section?.get("section")}`}
                          style={{
                            borderBottom: "1px solid rgb(48, 53, 62)",
                          }}
                        >
                          <li
                            className="list-group-item  bg-transparent  text-capitalize text-white text-decoration-none border-0 text-start ps-0"
                            style={{ padding: "0.65rem", paddingLeft: 0 }}
                          >
                            {section?.get("section")}
                          </li>
                        </a>
                      );
                    } else {
                      return <span key={section.id}></span>;
                    }
                  })}
                </div>
                <a
                  className="text-center d-block mx-auto btn p-0 w-50"
                  onClick={() => setOpen(false)}
                  href={data?.contractAddressButtonLink}
                  style={{
                    borderBottom: "1px solid rgb(53, 51, 62)",
                  }}
                >
                  <li
                    className="list-group-item  bg-transparent text-capitalize text-white text-decoration-none border-0 text-start ps-0"
                    style={{ padding: "0.65rem", paddingLeft: 0 }}
                  >
                    {data?.contractAddressButtonText}
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      className="ms-2 mb-1"
                      width={15}
                      height={15}
                      fill="white"
                      viewBox="0 0 1000 1000"
                      enableBackground="new 0 0 1000 1000"
                    >
                      <g>
                        <g>
                          <path d="M485,379.5l130.6,130.6l245.8-245.8l126.9,126.9l0.2-379L607.1,10l123.8,123.7L485,379.5L485,379.5z M986.4,546.3l-94.1-95.4l1.7,441.3l-784.7,0.4l0.8-782.7l438.9-2l-98-98H108C53.9,10,10,54,10,108v784c0,54.1,43.9,98,98,98h784c54.1,0,98-43.9,98-98L986.4,546.3z" />
                        </g>
                      </g>
                    </svg>
                  </li>
                </a>
              </ul>
              <div className="text-center mt-4">
                {socialAccounts?.map((account, index) => {
                  if (account?.type === "instagram") {
                    return (
                      <a
                        rel="noreferrer"
                        target="_blank"
                        data-aid="SOCIAL_INSTAGRAM_LINK"
                        aria-label="Instagram Social Link"
                        href={account?.link}
                        data-typography="LinkAlpha"
                        className="mx-2"
                        data-tccl="ux2.SOCIAL.social1.Section.Default.Link.Default.11656.click,click"
                        key={index}
                      >
                        <svg
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          width="40"
                          height="40"
                          data-ux="IconSocial"
                          className="x-el x-el-svg c1-1 c1-2 c1-95 c1-2v c1-3m c1-ax c1-ay c1-5m c1-b c1-c c1-az c1-b0 c1-d c1-b1 c1-b2 c1-b3 c1-b4 c1-b5 c1-b6 c1-b7 c1-b8 c1-e c1-f c1-g"
                        >
                          <g>
                            <path
                              fill="#E1306C"
                              d="M12 2c5.523 0 10 4.476 10 10 0 5.523-4.477 10-10 10-5.522 0-10-4.477-10-10C2 6.478 6.478 2 12 2z"
                            ></path>
                            <path
                              fill="#fff"
                              fillRule="evenodd"
                              d="M17.762 14.335c.025-.45.038-1.262.038-2.435s-.013-1.985-.038-2.435c-.052-1.066-.37-1.89-.953-2.474-.584-.584-1.408-.901-2.474-.953C13.885 6.013 13.073 6 11.9 6s-1.985.013-2.435.038c-1.066.052-1.89.37-2.474.953-.584.584-.901 1.408-.953 2.474C6.013 9.915 6 10.727 6 11.9s.013 1.985.038 2.435c.052 1.066.37 1.89.953 2.474.584.584 1.408.901 2.474.953.45.025 1.262.038 2.435.038s1.985-.013 2.435-.038c1.066-.052 1.89-.37 2.474-.953.584-.584.901-1.408.953-2.474zM11.9 7.06l-.588-.004a41.691 41.691 0 00-.81 0c-.185.003-.432.01-.742.023a6.09 6.09 0 00-.79.077 3.08 3.08 0 00-.55.142 1.993 1.993 0 00-.676.446c-.195.195-.343.42-.446.676a3.08 3.08 0 00-.142.55 6.09 6.09 0 00-.077.79c-.012.31-.02.557-.023.742-.002.184-.002.454 0 .81l.004.588-.004.588c-.002.356-.002.626 0 .81.003.185.01.432.023.742s.039.573.077.79c.039.219.086.402.142.55a2.001 2.001 0 001.122 1.122c.148.056.332.103.55.142.217.038.48.064.79.077.31.012.557.02.742.023.184.002.454.002.81 0l.588-.004.588.004c.356.002.626.002.81 0 .185-.003.432-.01.742-.023a6.09 6.09 0 00.79-.077c.219-.039.402-.086.55-.142a2.001 2.001 0 001.122-1.122c.056-.148.103-.332.142-.55a6.09 6.09 0 00.077-.79c.012-.31.02-.557.023-.742.002-.184.002-.454 0-.81l-.004-.588.004-.588c.002-.356.002-.626 0-.81-.003-.185-.01-.432-.023-.742a6.09 6.09 0 00-.077-.79 3.083 3.083 0 00-.142-.55 1.993 1.993 0 00-.446-.676 1.992 1.992 0 00-.676-.446 3.08 3.08 0 00-.55-.142 6.09 6.09 0 00-.79-.077 28.51 28.51 0 00-.742-.023 41.691 41.691 0 00-.81 0l-.588.004zm3.65 2.19a.68.68 0 00.207-.5.68.68 0 00-.208-.5.68.68 0 00-.5-.207.68.68 0 00-.499.208.68.68 0 00-.207.5c0 .194.07.36.207.499a.68.68 0 00.5.207.68.68 0 00.5-.207zm-.623 2.65c0 .84-.295 1.554-.884 2.143a2.918 2.918 0 01-2.143.884c-.84 0-1.554-.295-2.143-.884a2.918 2.918 0 01-.884-2.143c0-.84.295-1.554.884-2.143a2.919 2.919 0 012.143-.884c.84 0 1.554.295 2.143.884.59.589.884 1.303.884 2.143zm-1.06 0a1.89 1.89 0 00-.577-1.39 1.895 1.895 0 00-1.39-.577c-.543 0-1.006.192-1.39.576a1.895 1.895 0 00-.577 1.391c0 .543.192 1.006.576 1.39.385.385.848.577 1.391.577s1.006-.192 1.39-.577a1.89 1.89 0 00.577-1.39z"
                            ></path>
                          </g>
                        </svg>
                      </a>
                    );
                  } else if (account?.type === "linkedin") {
                    return (
                      <a
                        rel="noreferrer"
                        target="_blank"
                        data-aid="SOCIAL_LINKEDIN_LINK"
                        aria-label="LinkedIn Social Link"
                        href={account?.link}
                        data-typography="LinkAlpha"
                        className="mx-2"
                        data-tccl="ux2.SOCIAL.social1.Section.Default.Link.Default.11657.click,click"
                        key={index}
                      >
                        <svg
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          width="40"
                          height="40"
                          data-ux="IconSocial"
                          className="x-el x-el-svg c1-1 c1-2 c1-95 c1-2v c1-3m c1-ax c1-ay c1-5m c1-b c1-c c1-az c1-b0 c1-d c1-b1 c1-b2 c1-b3 c1-b4 c1-b5 c1-b6 c1-b7 c1-b8 c1-e c1-f c1-g"
                        >
                          <g>
                            <path
                              d="M12 2c5.523 0 10 4.476 10 10 0 5.523-4.477 10-10 10-5.522 0-10-4.477-10-10C2 6.478 6.478 2 12 2z"
                              fill="#2867B2"
                            ></path>
                            <path
                              d="M16.926 6H6.871C6.391 6 6 6.38 6 6.85v10.098c0 .47.39.852.871.852h10.056a.864.864 0 00.873-.852V6.85a.863.863 0 00-.874-.85z"
                              fill="#fff"
                            ></path>
                            <path
                              d="M7.75 10.424h1.753v5.63H7.75v-5.63zm.875-2.803a1.015 1.015 0 11-.002 2.03 1.015 1.015 0 01.002-2.03m1.973 2.803h1.678v.77h.024c.233-.443.804-.91 1.66-.91 1.771 0 2.098 1.166 2.098 2.682v3.089H14.31v-2.74c0-.652-.011-1.493-.909-1.493-.91 0-1.05.712-1.05 1.446v2.785H10.6v-5.63h-.002z"
                              fill="#2867B2"
                            ></path>
                          </g>
                        </svg>
                      </a>
                    );
                  } else if (account?.type === "twitter") {
                    return (
                      <a
                        rel="noreferrer"
                        target="_blank"
                        data-aid="SOCIAL_TWITTER_LINK"
                        aria-label="Twitter Social Link"
                        href={account?.link}
                        data-typography="LinkAlpha"
                        className="mx-2"
                        data-tccl="ux2.SOCIAL.social1.Section.Default.Link.Default.11658.click,click"
                        key={index}
                      >
                        <svg
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          width="40"
                          height="40"
                          data-ux="IconSocial"
                          className="x-el x-el-svg c1-1 c1-2 c1-95 c1-2v c1-3m c1-ax c1-ay c1-5m c1-b c1-c c1-az c1-b0 c1-d c1-b1 c1-b2 c1-b3 c1-b4 c1-b5 c1-b6 c1-b7 c1-b8 c1-e c1-f c1-g"
                        >
                          <g>
                            <path
                              d="M12 2c5.523 0 10 4.476 10 10 0 5.523-4.477 10-10 10-5.522 0-10-4.477-10-10C2 6.478 6.478 2 12 2z"
                              fill="#1DA1F2"
                            ></path>
                            <path
                              d="M16.975 9.755c.481-.345.9-.779 1.23-1.271a4.936 4.936 0 01-1.414.387 2.469 2.469 0 001.083-1.362 4.986 4.986 0 01-1.564.597 2.462 2.462 0 00-4.196 2.245A6.987 6.987 0 017.039 7.78a2.461 2.461 0 00.763 3.286 2.457 2.457 0 01-1.116-.309v.031c0 1.193.849 2.187 1.975 2.414a2.464 2.464 0 01-.649.085c-.16 0-.312-.013-.463-.042a2.466 2.466 0 002.3 1.71 4.94 4.94 0 01-3.645 1.018 6.968 6.968 0 003.773 1.107c4.53 0 7.006-3.75 7.006-7.005l-.008-.319z"
                              fill="#fff"
                            ></path>
                          </g>
                        </svg>
                      </a>
                    );
                  } else if (account?.type === "discord") {
                    return (
                      <a
                        href={account?.link}
                        target="_blank"
                        rel="noreferrer"
                        key={index}
                        className="mx-2"
                      >
                        <svg
                          width={40}
                          height={40}
                          viewBox="0 0 1024 1024"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ padding: "0.209rem" }}
                        >
                          <circle cx="512" cy="512" r="512" fill="#5865f2" />
                          <path
                            d="M689.43 349a422.21 422.21 0 0 0-104.22-32.32 1.58 1.58 0 0 0-1.68.79 294.11 294.11 0 0 0-13 26.66 389.78 389.78 0 0 0-117.05 0 269.75 269.75 0 0 0-13.18-26.66 1.64 1.64 0 0 0-1.68-.79A421 421 0 0 0 334.44 349a1.49 1.49 0 0 0-.69.59c-66.37 99.17-84.55 195.9-75.63 291.41a1.76 1.76 0 0 0 .67 1.2 424.58 424.58 0 0 0 127.85 64.63 1.66 1.66 0 0 0 1.8-.59 303.45 303.45 0 0 0 26.15-42.54 1.62 1.62 0 0 0-.89-2.25 279.6 279.6 0 0 1-39.94-19 1.64 1.64 0 0 1-.16-2.72c2.68-2 5.37-4.1 7.93-6.22a1.58 1.58 0 0 1 1.65-.22c83.79 38.26 174.51 38.26 257.31 0a1.58 1.58 0 0 1 1.68.2c2.56 2.11 5.25 4.23 8 6.24a1.64 1.64 0 0 1-.14 2.72 262.37 262.37 0 0 1-40 19 1.63 1.63 0 0 0-.87 2.28 340.72 340.72 0 0 0 26.13 42.52 1.62 1.62 0 0 0 1.8.61 423.17 423.17 0 0 0 128-64.63 1.64 1.64 0 0 0 .67-1.18c10.68-110.44-17.88-206.38-75.7-291.42a1.3 1.3 0 0 0-.63-.63zM427.09 582.85c-25.23 0-46-23.16-46-51.6s20.38-51.6 46-51.6c25.83 0 46.42 23.36 46 51.6.02 28.44-20.37 51.6-46 51.6zm170.13 0c-25.23 0-46-23.16-46-51.6s20.38-51.6 46-51.6c25.83 0 46.42 23.36 46 51.6.01 28.44-20.17 51.6-46 51.6z"
                            fill="#fff"
                          />
                        </svg>
                      </a>
                    );
                  } else if (account?.type === "facebook") {
                    return (
                      <a
                        href={account?.link}
                        target="_blank"
                        rel="noreferrer"
                        key={index}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 48 48"
                          width="40"
                          height="40"
                          className="mx-2"
                        >
                          <linearGradient
                            id="Ld6sqrtcxMyckEl6xeDdMa"
                            x1="9.993"
                            x2="40.615"
                            y1="9.993"
                            y2="40.615"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop offset="0" stopColor="#2aa4f4" />
                            <stop offset="1" stopColor="#007ad9" />
                          </linearGradient>
                          <path
                            fill="url(#Ld6sqrtcxMyckEl6xeDdMa)"
                            d="M24,4C12.954,4,4,12.954,4,24s8.954,20,20,20s20-8.954,20-20S35.046,4,24,4z"
                          />
                          <path
                            fill="#fff"
                            d="M26.707,29.301h5.176l0.813-5.258h-5.989v-2.874c0-2.184,0.714-4.121,2.757-4.121h3.283V12.46 c-0.577-0.078-1.797-0.248-4.102-0.248c-4.814,0-7.636,2.542-7.636,8.334v3.498H16.06v5.258h4.948v14.452 C21.988,43.9,22.981,44,24,44c0.921,0,1.82-0.084,2.707-0.204V29.301z"
                          />
                        </svg>
                      </a>
                    );
                  } else {
                    return <></>;
                  }
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
